import React from 'react';
import { motion } from 'framer-motion';
import { Smartphone, CreditCard, ShieldCheck, Download, BarChart3 } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 md:px-6 lg:px-8 w-full overflow-hidden" data-id="element-126">
      
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none -z-10" data-id="element-127">
        <div className="absolute top-[-20%] left-[-10%] w-[60vw] h-[60vw] bg-cyan-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-128" />
        <div className="absolute bottom-[-20%] right-[-10%] w-[60vw] h-[60vw] bg-green-500/10 rounded-full blur-[100px] md:blur-[150px]" data-id="element-129" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col items-start text-left" data-id="element-131">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-cyan-400 text-sm font-semibold mb-6 tracking-wide uppercase" data-id="element-132">
            <span className="relative flex h-2 w-2" data-id="element-133">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-75" data-id="element-134"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-cyan-500" data-id="element-135"></span>
            </span>
            Versión 3.0 Ya Disponible
          </div>

          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-white leading-[1.1] tracking-tight mb-6" data-id="element-136">
            Controla tu Inventario y Actualiza Precios <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-green-400" data-id="element-137">en Segundos</span>
          </h1>

          <p className="text-gray-300 text-lg md:text-xl leading-relaxed mb-8 font-light max-w-xl" data-id="element-138">
            El sistema financiero en Excel definitivo para <strong className="text-white font-semibold" data-id="element-139">Minimarkets, Repuestos, Licorerías y Bodegas</strong>. Conoce tu ganancia real mensual sin pagar costosas mensualidades.
          </p>

          <div className="w-full sm:w-auto flex flex-col gap-4" data-id="element-140">
            <a href="#comprar" className="w-full sm:w-auto px-8 py-4 bg-gradient-to-r from-green-500 to-cyan-500 hover:from-green-400 hover:to-cyan-400 text-black font-black text-lg md:text-xl rounded-xl text-center transition-all duration-300 shadow-[0_0_30px_rgba(34,197,94,0.3)] hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] uppercase tracking-wide flex items-center justify-center gap-2" data-id="element-141">
              <Download className="w-6 h-6" data-id="element-142" />
              Obtener por solo $24.99
            </a>
            
            <div className="flex flex-col gap-2" data-id="element-143">
              <div className="flex items-center justify-center sm:justify-start gap-2 text-sm text-gray-400 font-medium" data-id="element-144">
                <ShieldCheck className="w-4 h-4 text-green-400" data-id="element-145" />
                <span data-id="element-146">Único pago de por vida. Cero mensualidades.</span>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative flex justify-center lg:justify-end group lg:ml-10 mt-10 lg:mt-0" data-id="element-147">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/20 to-green-500/20 rounded-3xl blur-[40px] group-hover:blur-[60px] transition-all duration-500" data-id="element-148" />
          <div className="relative w-full max-w-sm md:max-w-xl rounded-3xl overflow-hidden border border-cyan-500/30 shadow-[0_0_60px_rgba(34,211,238,0.25)] bg-[#0a0a0a] p-2" data-id="element-149">
             {/* AQUÍ VA TU VIDEO GENERAL */}
             <div className="aspect-video w-full rounded-2xl overflow-hidden" data-id="element-150">
                <iframe className="w-full h-full" src="https://www.youtube.com/embed/dSrultJNhdQ?autoplay=0&rel=0" title="Demo Masterkit Elite" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-151">
                </iframe>
             </div>
          </div>
        </motion.div>
      </div>
    </section>;
}